<div class="tile-board-viewer">
  <!-- Filter Bar -->
  <bhub-filter-bar 
    *ngIf="filterBar"
    [filterBar]="filterBar"
    [isEditing]="false"
    (selectedFiltersChanged)="onSelectedFiltersChanged($event)">
  </bhub-filter-bar>

  <!-- Tile Board Content -->
  <div class="gridster-scrollable" *ngIf="board; else noBoardTemplate">
    <gridster class="gridster-class" [options]="gridsterOptions">
      <gridster-item class="gridster-item" *ngFor="let item of board.itemList" [item]="item">
        <ng-container *ngComponentOutlet="item.data.component; inputs: { data: item.data.data, mode: item.data.mode };"></ng-container>
      </gridster-item>
    </gridster>
  </div>

  <!-- No Board Selected Template -->
  <ng-template #noBoardTemplate>
    <div class="no-board-message">
      <div>
        <mat-icon style="font-size: 48px; height: 48px; width: 48px; color: #ccc;">dashboard</mat-icon>
        <p>No tile board selected</p>
      </div>
    </div>
  </ng-template>
</div>